import React, { useState } from 'react';
import { Button, Row, Form } from 'react-bootstrap';

import { useHttpUtils } from '../../Utilities/useHttpUtils';
import { useBusinessUnits } from '../../Utilities/useBusinessUnits';
import { useSiteCode } from '../../Utilities/useSiteCode';
import useAlert from '../../Alerts/useAlert';
import AdminTile from './AdminTile';

export default function CloneConfiguration() {
    const { businessUnits } = useBusinessUnits(false);
    const { setAlert } = useAlert();
    const { fetchBlobAuthenticated, downloadFile } = useHttpUtils();
    const [variant, setVariant] = useState<string>("");
    const [businessUnit, setBusinessUnit] = useState<number>(0);
    const [error, setError] = useState<string | null>(null);
    const siteCode = useSiteCode();

    const cloneConfiguration = () => {
        fetchBlobAuthenticated(`api/v1/admin/cloneConfiguration?businessUnitId=${businessUnit}`)
            .then(response => {
                if (!response.ok) {
                    return response
                        .json()
                        .then(error => Promise.reject(error));
                }
                return response.blob();
            })
            .then((response) => {
                return response = response.slice(0, response.size, "application/xml");
            })
            .then(blob => {
                setVariant("");
                setError(null);

                let buCode = "All"
                if (businessUnit !== 0) {
                    buCode = businessUnits.find(bu => bu.businessUnitId === businessUnit)?.code ?? "Unknown";
                }

                downloadFile(blob, `${siteCode}-${buCode}-config.sql`);
                setAlert("success", "Configuration SQL Generated", "SQL to clone configuration has been generated and downloaded");
            })
            .catch(error => {
                setVariant("danger");
                setAlert("danger", "Failed to clone configuration", error.detail);
                setError(error.detail);
            });
    };

    function CloneConfig() {
        return (
            <>
                <Row className="mt-1 mb-2">
                    <Form>
                        <Form.Group>
                            <Form.Label><strong>Business Unit</strong></Form.Label>
                            <Form.Select className="config-select" value={businessUnit} onChange={(e) => setBusinessUnit(parseInt(e.target.value))}>
                                <option value="0" key={0} >All</option>
                                {businessUnits.map((bu) => <option value={bu.businessUnitId} key={bu.businessUnitId}>{bu.name}</option>)}
                            </Form.Select>
                        </Form.Group>
                    </Form>
                </Row>
                <Button onClick={cloneConfiguration}>Clone</Button>
                {error &&
                    <span className="text-danger">{error}</span>
                }
            </>
        );
    }

    return (
        <AdminTile
            title={"Clone configuration"}
            description={"Generates a SQL script that can be applied to a database to provide a clone of this sites configuration"}
            variant={variant}
            onRefresh={null}>
            <CloneConfig />
        </AdminTile>
    );
}